<template>
  <div>
    <v-snackbar v-model="snackbar.visible"
                :timeout="snackbar.timeout"
                :color="snackbar.color"
                top>
      {{ snackbar.text }}
    </v-snackbar>
    <h1>Leistungsauszüge generieren</h1>
    <v-chip-group>
      <v-chip v-on:click="quickSelect('tm')">Diesen Monat</v-chip>
      <v-chip v-on:click="quickSelect('lm')">Letzten Monat</v-chip>
      <v-chip v-on:click="quickSelect('ty')">Dieses Jahr</v-chip>
      <v-chip v-on:click="quickSelect('ly')">Letztes Jahr</v-chip>
    </v-chip-group>
    <DatePickerField v-model="from" label="Von"></DatePickerField>
    <DatePickerField v-model="to" label="Bis"></DatePickerField>
    <v-autocomplete v-model="selectedOrganisationalUnits" v-bind:loading="usersLoading" v-on:change="oeChanged" multiple
                    chips deletable-chips clearable
                    :items="organisationalUnits" label="Organisationseinheit"
                    prepend-icon="person"></v-autocomplete>
    <v-autocomplete v-model="selectedUsers" v-bind:loading="usersLoading" multiple chips deletable-chips clearable
                    :items="users" :item-text="getUserName" item-value="id" label="Leistungserbringer"
                    prepend-icon="person"></v-autocomplete>
    <v-btn color="primary" v-on:click="generate">Auszug generieren</v-btn>
  </div>
</template>

<script>
import DatePickerField from "../components/DatePickerField";
import {reportServce} from "../services/reportService";
import {accountService} from "../services/accountService";

export default {
  name: "Reports",
  components: {DatePickerField},
  data: () => ({
    organisationalUnits: [],
    selectedOrganisationalUnits: [],
    organisationalUnitsLoading: true,
    users: [],
    selectedUsers: [],
    usersLoading: true,
    from: new Date().setFullYear(new Date().getFullYear() - 1),
    to: new Date(),
    snackbar: {
      visible: false,
      text: "",
      timeout: 5000,
      color: ""
    },
  }),
  methods: {
    quickSelect(item) {

      let from = new Date();
      let to = new Date();
      switch (item) {
        case "tm":
          from.setDate(from.getDate() - (from.getDate() - 1));
          to.setDate(new Date(to.getFullYear(), to.getMonth() + 1, 0).getDate())
          break;

        case "lm":
          from.setDate(from.getDate() - (from.getDate() - 1));
          from.setMonth(from.getMonth() - 1)
          to.setDate(new Date(to.getFullYear(), to.getMonth(), 0).getDate());
          to.setMonth(to.getMonth() - 1);
          break;

        case "ty":
          from.setMonth(0);
          from.setDate(1)
          to.setDate(new Date(to.getFullYear(), 12, 0).getDate());
          to.setMonth(11);
          to.setFullYear(from.getFullYear())
          break;
        case "ly":
          from.setFullYear(from.getFullYear() - 1)
          from.setMonth(0);
          from.setDate(1)
          to.setDate(new Date(to.getFullYear(), 12, 0).getDate());
          to.setMonth(11);
          to.setFullYear(from.getFullYear())
      }
      this.from = from;
      this.to = to;
    },
    oeChanged() {
      let oeUsers = this.users.filter(user => this.selectedOrganisationalUnits.includes(user.organisationalUnitId));
      this.selectedUsers = oeUsers.map(user => user.id);
    },
    getUserName(item) {
      return item.firstname + " " + item.lastname;
    },
    generate() {
      if (this.selectedUsers.length === 0) {
        this.snackbar.visible = true;
        this.snackbar.text = "Keine Benutzer ausgewählt";
        return;
      }
      reportServce.getReport(new Date(this.from), new Date(this.to), this.selectedUsers).catch(reason => {
        this.snackbar.visible = true;
        this.snackbar.text = reason;
      });
    }
  },
  created() {
    let self = this;
    accountService.getQuery(this.query).then(response => {
      self.users = response;
      self.usersLoading = false;
    }).catch((error) => {
      console.log(error);
      accountService.refreshToken().then(() => this.fetchUsers()).catch(() => accountService.signOut())
    })

    accountService.getOrganisationalUnits().then(value => {
      for (let i = 0; i < value.length; i++) {
        self.organisationalUnits.push({
          text: value[i].name,
          value: value[i].id,
        });
      }
      self.organisationalUnitsLoading = false;
    });
  }
}
</script>

<style scoped>

</style>